import { Form, Offcanvas } from "react-bootstrap";
import { set, useForm } from "react-hook-form";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";

interface IesaAdvantage {
  show: boolean;
  handleClose: () => void;
  data?: any;
}

type FormData = {
  title: string;
  icon: File | null;
};

const AddIesaAdvantage = ({ show, handleClose, data }: IesaAdvantage) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormData>();
  const [isLoading, setLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [fileError, setFileError] = useState<string>("");

  console.log("a", data?._id);
  useEffect(() => {
    if (data) {
      reset({
        title: data.title,
      });
    } else {
      reset({});
    }
  }, [show]);

  const onSubmit = (request: FormData) => {
    setLoading(true);
    if (fileError) {
      toast.error(fileError);
      return;
    }
    const formData = new FormData();
    formData.append("title", request.title);
    if (file) {
      formData.append("icon", file);
    }
    if (data?._id) {
      WebService.fileUploadPutAPI({
        action: `iesa-advantages/edit-iesa-advantage/${data._id}`,
        body: formData,
      })
        .then((res: any) => {
          toast.success(res.message);
          reset();
          handleClose();
          setFile(null);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    } else {
      WebService.fileUploadAPI({
        action: `iesa-advantages/add-iesa-advantage`,
        body: formData,
      })
        .then((res: any) => {
          toast.success(res.message);
          reset();
          handleClose();
          setFile(null);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    }
  };
  const ALLOWED_IMAGE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/svg+xml",
  ];
  return (
    <Offcanvas
      show={show}
      onHide={() => {
        reset();
        handleClose();
      }}
      placement="end"
      className="offcanvas-custom"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {data ? "Edit IESA Advantage" : "Add IESA Advantage"}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2" controlId="title">
            <Form.Label className="label">
              Title<span className="text-danger"> *</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter title"
              {...register("title", { required: "Title is required" })}
            />
            {errors.title && (
              <div className="error-message">{errors.title.message}</div>
            )}
          </Form.Group>
          <Form.Group className="mb-2" controlId="icon">
            <Form.Label className="label">Icon</Form.Label>
            <Form.Control
              type="file"
              accept="image/.png,.jpg,.jpeg,.svg"
              className="custom-image-upload"
              onChange={(e) => {
                const input = e.target as HTMLInputElement;
                const selectedFile = input.files?.[0];

                if (!selectedFile) return;

                if (!ALLOWED_IMAGE_TYPES.includes(selectedFile.type)) {
                  setFileError(
                    "Image format not supported. Please upload PNG, JPG, JPEG or SVG. image"
                  );
                  // console.log(fileError)
                  //      toast.error(fileError);
                  setFile(null);
                  input.value = ""; // reset input
                  return;
                }

                // ✅ valid
                setFileError("");
                setFile(selectedFile);
              }}
            />
            {fileError && (
                <p className="text-danger mt-1" style={{ fontSize: "13px" }}>
                  {fileError}
                </p>
              )} 
          </Form.Group>
          {(file || data?.icon) && (
            <div className="mb-2 event-image">
              <img
                src={file ? URL.createObjectURL(file) : data?.icon}
                alt="Event"
                style={{
                  maxWidth: "100%",
                  maxHeight: 200,
                  objectFit: "contain",
                }}
              />
            </div>
          )}
        </Form>
      </Offcanvas.Body>
      <div className="d-flex justify-content-end p-3">
        <CustomButton
          isLoading={isLoading}
          label="Save"
          className="w-100"
          onClick={handleSubmit(onSubmit)}
        />
      </div>
    </Offcanvas>
  );
};

export default AddIesaAdvantage;
